import { useEffect, useState } from "react";
import { MainLayout } from "../../layout/MainLayout";
import DataTable, { TableColumn } from "react-data-table-component";
import { Feedback, emptyFeedback } from "../../interfaces/Feedback";
import Moment from 'moment';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LoadingSpinner } from "../../elements/LoadingSpinner";

export default function Feedbacks() {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const isAdmin = localStorage.getItem('isAdmin');

    const [feedbacks, setFeedbacks] = useState<Feedback[]>([]);
    const [loading, setLoading] = useState(true);
    const [reloadData, setReloadData] = useState(0);

    const columns: TableColumn<Feedback>[] = [
        {
            name: t("Id"),
            selector: (row: Feedback) => row._id,
            sortable: true,
            width: '200px',
            omit: true,
        },
        {
            name: t("Issue"),
            selector: (row: Feedback) => row.issue,
            sortable: true,
            width: '150px',
        },
        {
            name: t("Section"),
            selector: (row: Feedback) => row.section,
            sortable: true,
            width: '150px',
        },
        {
            name: t("Body"),
            selector: (row: Feedback) => row.body,
            sortable: false,
            grow: 2,
        },
        {
            name: t("Date"),
            selector: (row: Feedback) => Moment(row.date).format('DD/MM/YYYY HH:mm'),
            sortable: true,
            width: '150px',
        },
        {
            name: t("User"),
            selector: (row: Feedback) => row.user?.email || '-',
            sortable: true,
            width: '200px',
        },
    ];

    const ExpandedComponent = ({ data }: { data: Feedback }) => (
        <div style={{ padding: '15px' }}>
            <div><strong>{t("Id")}:</strong> {data._id}</div>
            <div><strong>{t("Body")}:</strong> {data.body}</div>
        </div>
    );

    useEffect(() => {
        setLoading(true);
        const requestOptionsPost = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/feedback', requestOptionsPost)
            .then(response => {
                if (response.status !== 200) {
                    navigate('/');
                }
                return response.json();
            })
            .then(data => {
                setFeedbacks(data);
                setLoading(false);
            });
    }, [reloadData]);



    return (
        <MainLayout>
            <div className="container-fluid">
                <div className="row">
                    { isAdmin &&
                        <div className="admin-feedbacks-container">
                                    <div className="page-header">
                                        <h1>{ t("Feedback management") }</h1>
                                    </div>
                                    <div className="admin-feedbacks-table-container">
                                        <DataTable
                                            columns={columns}
                                            data={feedbacks.filter((f: Feedback) => f.user != null)}
                                            progressPending={loading}
                                            progressComponent={<LoadingSpinner />}
                                            pagination
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[10, 20, 30, 50]}
                                            highlightOnHover
                                            striped
                                            responsive
                                            noDataComponent={t("No feedback found")}
                                            expandableRows
                                            expandableRowsComponent={ExpandedComponent}
                                        />
                                    </div>
                                </div>
                    }
                    { !isAdmin &&
                        <div className="admin-feedbacks-container">
                            { t("You are not allowed to access this section.") }
                        </div>
                    }
                </div>
            </div>
        </MainLayout>);
}